// extracted by mini-css-extract-plugin
export default {"select":"events-registration-client-js-components-___ConsentToPublishDropdown-module__select___h3oek"};